import BaseDrawTool from "./BaseDrawTool";
import {AnnotationsConstants} from "../../../utils/const";
import Polygon from "ol/geom/Polygon";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {FIXED_ANNO_WIDTH} from "../drawer/draw_tool_keys";

class Point extends BaseDrawTool {

    id = "Point";
    name = "Point";
    type = "Circle";
    shape = AnnotationsConstants.POLYGON
    icon = <FiberManualRecordIcon/>;
    freehand = false;

    geometryFunction = (coordinates) => {
        const [[x, y]] = coordinates;
        const geometryCoordinates = [
            [x + FIXED_ANNO_WIDTH / 2, y],
            [x - FIXED_ANNO_WIDTH / 2, y],
            [x + FIXED_ANNO_WIDTH / 2, y],
        ];
        return new Polygon([geometryCoordinates]);
    };

    getTitle = (feature) => {
        return "Label"
    }
}

export default Point;
